import React from 'react';
import { PageHeader } from '@ant-design/pro-layout';
import { ImportantTripDocumentFlags } from 'components/documents/important-trip-document-flags';
import { TripAddAdditionalCost } from 'components/trips/trip-add-additional-cost';
import { TripAddCargoDrawerWithButton } from 'components/trips/trip-add-cargo-drawer-with-button';
import { TripEdit } from 'components/trips/trip-edit';
import { TripExtraActions } from 'components/trips/trip-extra-actions';
import { TripPrinting } from 'components/trips/trip-printing';
import { TripSetTask } from 'components/trips/trip-set-task';
import { TripSoldPdfGeneration } from 'components/trips/trip-sold-pdf-generation';
import { TripStatusEdit } from 'components/trips/trip-status-edit';
import { TripStatusTag } from 'components/trips/trip-status-tag';
import type { ITripPageHeaderProps } from './types';

export const TripPageHeader: React.FC<ITripPageHeaderProps> = (props) => {
  const { trip } = props;

  return (
    <PageHeader
      title={trip.compositeId}
      tags={[
        <TripStatusTag key='trip-status' status={trip.status} />,
        ...(trip.documents
          ? [<ImportantTripDocumentFlags key='important-trip-documents' documents={trip.documents} />]
          : []),
      ]}
      extra={[
        <TripAddAdditionalCost key='trip-additional-cost' tripId={trip.id} />,
        <TripSetTask key='set-task-button' trip={trip} />,
        <TripAddCargoDrawerWithButton key='add-cargo-button' tripId={trip.id} />,
        <TripSoldPdfGeneration key='generate-order' trip={trip} />,
        <TripStatusEdit key='status-edit' trip={trip} />,
        <TripPrinting key='print' tripId={trip.id} />,
        <TripEdit key='edit' trip={trip} />,
        <TripExtraActions key='extra-actions' tripId={trip.id} />,
      ]}
      onBack={() => history.back()}
    />
  );
};
